import React from "react";
import * as Yup from 'yup';
import { UserDataDto } from "../../generated"
import { Forms } from "../../common/components/CmForms";
const { Form, FormText, FormCheck, ActionBar } = Forms<NewOperatore>()


interface Props {
    operatore: NewOperatore;
    onSubmit: (customer: NewOperatore) => void;
    onCancel: () => void;
}

export class NewOperatore extends UserDataDto {
    confirmPassword: string;
    confirmUsername: string;
}
export default class OperatoreForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<NewOperatore>>({
        nomeOperatore: Yup
            .string()
            .required('Campo obbligatorio'),
        username: Yup
            .string()
            .email("deve essere una casella di posta elettronica")
            .required('Campo obbligatorio'),
        confirmUsername: Yup
            .string()
            .email("deve essere una casella di posta elettronica")
            .required('Campo obbligatorio')
            .oneOf([Yup.ref("username"), null], 'GLi username non corrispondono'),
        password: Yup
            .string()
            .required('Campo obbligatorio'),
        confirmPassword: Yup
            .string()
            .oneOf([Yup.ref("password"), null], 'Le password non corrispondono'),
    })

    render() {
        const { operatore } = this.props;
        if (!operatore)
            return null;
        return (
            <Form
                onSubmit={this.props.onSubmit}
                initialValues={operatore}
                validationSchema={OperatoreForm.validationSchema}
            >
                <>
                    <div className="row">
                        <div className="col-12">
                            <FormText
                                name="nomeOperatore"
                                label="Nome Operatore"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                name="username"
                                label="Email"
                                type="email"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                name="confirmUsername"
                                label="Conferma username"
                                type="email"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                name="password"
                                label="Password"
                                type="password"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormText
                                name="confirmPassword"
                                label="Conferma password"
                                type="password"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormCheck
                                name="amministratore"
                                label="Amministratore"
                            />
                        </div>
                        <div className="col-12 col-md-6">
                            <FormCheck
                                name="disabilitato"
                                label="Disabilitato"
                            />
                        </div>
                    </div>
                    <ActionBar
                        onCancel={this.props.onCancel}
                    />
                </>
            </Form>
        );
    }
}
